export default __webpack_public_path__ + "static/media/business_show_4.76f5586b.png";